import { environment } from 'src/environments/environment';

export const stripe = Stripe(environment.stripe.key);
export const stripeElements = stripe.elements();
